import { css } from "../../../styled-system/css";

export const styles = {
  root: (isBlue: boolean) =>
    css({
      maxWidth: "894px",
      margin: "0 auto",
      background: isBlue ? "paleBlueLight" : "transparent",
      textAlign: "center",
    }),
  wrapper: () =>
    css({
      maxWidth: "528px",
      marginTop: 0,
      marginX: "auto",
      marginBottom: "baseUnit.mobile3",
    }),
  mainHeading: () =>
    css({
      textAlign: "center",
    }),
  secondHeading: () =>
    css({
      marginBottom: "baseUnit.mobile3",
      fontSize: "heading.H3.mobile",
      lineHeight: "heading.H3.mobile",
      textAlign: "center",
      desktop: {
        fontSize: "heading.H3.desktop",
        lineHeight: "heading.H3.desktop",
      },
    }),
  partnerLogo: () =>
    css({
      maxWidth: "160px",
      maxHeight: "100px",
      margin: "baseUnit.mobile1",
    }),
  linkWrapper: () =>
    css({
      "& a": {
        color: "oceanBlue",
        textDecorationColor: "oceanBlue",
        _hover: {
          color: "abyssBlue",
          textDecorationColor: "abyssBlue",
        },
        desktop: {
          lineHeight: "body.horse",
        },
      },
    }),
};
